// import Item from '@/components/AvatarList/Item'
import Clipboard from 'clipboard'

export const copyTextMixin = {
  data () {
    return {
      curText: ''
    }
  },

  methods: {
    copy (val) {
      var clipboard = new Clipboard('.tag-read', {
        text: function () {
          return val
        }
      })
      clipboard.on('success', e => {
        this.curText = val
        // const tagRead = document.getElementsByClassName('tag-read')
        // for (const tag of tagRead) {
        //   const oldClassName = tag.className
        //   tag.className = oldClassName + ' copySelClass'
        //   setTimeout(() => {
        //     tag.className = oldClassName
        //   }, 3000)
        // }
        setTimeout(() => {
          this.curText = ''
        }, 3000)
         this.$message.success('复制成功')
          // 释放内存
          clipboard.destroy()
        })
        clipboard.on('error', e => {
          // 不支持复制
          this.$message.error('该浏览器不支持自动复制')
          // 释放内存
          clipboard.destroy()
        })
    }
  },
  created () {
  }

}
